import { PropsWithChildren } from "react";

import usePermissions from "../../../hooks/usePermissions.hook";

declare type Props = PropsWithChildren<{
  restriction?: string | null | undefined;
  restrictions?: string[] | null | undefined;
}>;

const NextRestrictedElement = ({ restriction, restrictions, children }: Props) => {
  let usedRestrictions: string[] = [];

  if (restrictions && restrictions.length > 0) {
    usedRestrictions = restrictions;
  }

  if (!restrictions && restriction) {
    usedRestrictions = [restriction];
  }

  const { permitted } = usePermissions({ restrictions: usedRestrictions });

  return <>{permitted && children}</>;
};

export default NextRestrictedElement;
